import { SalesLead } from "kinnect-models";
import { KActionDialog } from "kinnect-general";

export default {
	name: "SalesLeadDeleteDialog",

	props: {
		...KActionDialog.options.props,

		confirmButtonColor: {
			...KActionDialog.options.props.confirmButtonColor,
			default: "error"
		},

		confirmButtonText: {
			...KActionDialog.options.props.confirmButtonText,
			default: "Delete"
		},

		item: {
			required: true,
			type: SalesLead
		},

		title: {
			...KActionDialog.options.props.title,
			default: "Delete Sales Lead"
		}
	},

	render() {
		return <KActionDialog
			attrs={{
				...this.$props,
				loading: this.$wait.is( "delete sales lead" )
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{
				default: () => <div>Are you sure you want to delete this sales lead for <strong>{this.item.companyName}</strong>?</div>,

				...this.$scopedSlots
			}}
		></KActionDialog>;
	}
};
